import React, {useState, useEffect} from 'react';
import {Link,NavLink } from 'react-router-dom'
import { useHistory } from 'react-router-dom';
// import Cookies from 'js-cookie';
import logo from '../../../assets/images/logo.png';
import { useMenu } from '../../../context/MenuContext';
import axiosInstance from "../../../services/api";
import Loader from '../../Commons/Loader';
function Sidebar() {
  const history = useHistory(); // Define inside the component
  const menuArr = useMenu();
  const passwordUpdated = JSON.parse(localStorage.getItem("passwordUpdated"));
  const [loading, setLoading] = useState(false);
  if(!passwordUpdated){
      history.push('/changepassword');
      console.log("kiop")
  }

  
  
  const menuArrNw = menuArr.menuArr;
  const iconMapping = {
    'user-management': 'fa-users',
    'role-and-permission-management': 'fa-cogs',
    'hotel-management': 'fa-hotel',
    'password-management': 'fa-key',
    'usage-report': 'fa-th',
    'incident-management': 'fa-tools',
    'max-hospital-usage-report': 'fa-file-alt'
    // Add more mappings as needed
  };

  const handleLogout = async () => {
    setLoading(true);
    try {
      // Call the logout API
      await axiosInstance.get('auth/logout'); // Adjust the endpoint if necessary
      
      // Clear authentication-related storage
      localStorage.clear();
      sessionStorage.clear(); // Clear session storage if applicable
  
      // Redirect to the login page after clearing storage
      setTimeout(() => {
        history.replace('/'); // Replace with your navigation logic
        window.location.reload(); 
      }, 500); // 3-second delay for user experience
    } catch (error) {
      console.error('Error during logout:', error);
  
      // Handle API call errors (optional: display a message to the user)
    }finally {
      setLoading(false);
    }
  };
  const handleNavClick = () => {
      //document.body.classList.add("sidebar-closed sidebar-collapse"); // Add class on click
      document.body.classList.remove("sidebar-open"); // Add class on click
  };

  
    return (
        <>
         {loading && <Loader />} 
         <aside className="main-sidebar sidebar-dark-primary">
          {/* Brand Logo */}
          <div className="brand-link d-flex justify-between items-center">
            <img src={logo} alt="AdminLTE Logo" className="brand-image" />
            <a className="nav-link nav-link-close" data-widget="pushmenu" href="#" role="button">
              <i className="fas fa-times" /></a>
          </div>
        
          {/* Sidebar */}
          <div className="left-sidebar">
            <div className="left-sidebar-inner">
              <div className="sidebar custom-sidebar">
                <nav className="mt-2">
                  <ul
                    className="nav nav-pills nav-sidebar flex-column"
                    data-widget="treeview"
                    role="menu"
                    data-accordion="false"
                  >
                    <li className="nav-item">
                      <NavLink to="/dashboard" className="nav-link" onClick={handleNavClick}>
                        <i className="nav-icon fas fa-tachometer-alt"></i>
                        <p>Dashboard</p>
                      </NavLink>
                    </li>
                    {menuArrNw.map((menu, index) => {
                      // Filter out subMenus with 'Edit' in the title
                      const filteredSubMenus = menu.subMenus ? menu.subMenus.filter(subMenu => !subMenu.title.includes('Edit') && subMenu.id !== 'delete-role') : [];

                      // Get the dynamic icon class and modified parent URL
                      const iconClass = iconMapping[menu.id] || 'fa-circle';

                      return menu.type === "dropdown" ? (
                        // Render dropdown menu items
                        <li className="nav-item menu-open menu-is-opening" key={index}>
                          <a className="nav-link">
                            <i className={`nav-icon fas ${iconClass}`} />
                            <p>{menu.title}</p>
                          </a>
                          {filteredSubMenus.length > 0 && (
                            <ul className="nav nav-treeview">
                              {filteredSubMenus.map((subMenu, subIndex) => (
                                <li key={subIndex} className="nav-item">
                                  <NavLink to={`/${subMenu.id}`} className="nav-link" onClick={handleNavClick}>
                                    <i className="fas fa-angle-right nav-icon"></i>
                                    <p>{subMenu.title}</p>
                                  </NavLink>
                                </li>
                              ))}
                            </ul>
                          )}
                        </li>
                      ) : (
                        // Render non-dropdown menu items
                        <li className="nav-item" key={index}>
                          <NavLink to={`/${menu.id}`} className="nav-link" onClick={handleNavClick}>
                            <i className={`nav-icon fas ${iconClass}`}></i>
                            <p>{menu.title}</p>
                          </NavLink>
                        </li>
                      );
                    })}
                    {/* <li className="nav-item menu-open menu-is-opening">
                      <a className="nav-link">
                        <i className="nav-icon fas fa-tachometer-alt"></i>
                        <p>Incident Management</p>
                      </a>
                      <ul className="nav nav-treeview">
                        <li className="nav-item">
                            <NavLink to="/upload-report" className="nav-link" onClick={handleNavClick}>
                              <i className="fas fa-angle-right nav-icon"></i>
                              <p>Upload Report</p>
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to="/download-report" className="nav-link" onClick={handleNavClick}>
                              <i className="fas fa-angle-right nav-icon"></i>
                              <p>Download Report</p>
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to="/dashboard-management" className="nav-link" onClick={handleNavClick}>
                              <i className="fas fa-angle-right nav-icon"></i>
                              <p>Dashboard Management</p>
                            </NavLink>
                        </li>
                      </ul>
                    </li> */}
                  </ul>
                </nav>
              </div>
              <ul className="logout-footer">
                <li>
                  <a onClick={handleLogout}>
                    <i className="nav-icon fas fa-power-off" /> Logout
                  </a>
                </li>
              </ul>
            </div>
          </div>
          {/* /.sidebar */}
        </aside>
      
        </>
    );
  }
  
  export default Sidebar;